"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStateProperty = exports.statePropertyDefinition = void 0;
exports.statePropertyDefinition = {
    view: { label: 'State' },
    constraints: [
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'state',
};
const isStateProperty = (prop) => {
    return prop.name === exports.statePropertyDefinition.name;
};
exports.isStateProperty = isStateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9zdGF0ZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7SUFDeEIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLE9BQU87Q0FDa0IsQ0FBQTtBQUkxQixNQUFNLGVBQWUsR0FBRyxDQUFDLElBQWtCLEVBQXlCLEVBQUU7SUFDM0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLCtCQUF1QixDQUFDLElBQUksQ0FBQTtBQUNuRCxDQUFDLENBQUE7QUFGWSxRQUFBLGVBQWUsbUJBRTNCIn0=